"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EThirdPartyAuthMethod = exports.EThirdPartyRole = void 0;
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const Contact_1 = __importDefault(require("./Contact"));
var EThirdPartyRole;
(function (EThirdPartyRole) {
    EThirdPartyRole["COURTIER"] = "COURTIER";
    EThirdPartyRole["AGENT_IMMOBILIER"] = "AGENT_IMMOBILIER";
    EThirdPartyRole["AVOCAT"] = "AVOCAT";
    EThirdPartyRole["BANQUE"] = "BANQUE";
    EThirdPartyRole["TUTELLE"] = "TUTELLE";
    EThirdPartyRole["SYNDIC"] = "SYNDIC";
    EThirdPartyRole["EXPERT"] = "EXPERT";
    EThirdPartyRole["GENEALOGISTE"] = "GENEALOGISTE";
    EThirdPartyRole["AUTRE"] = "AUTRE";
})(EThirdPartyRole || (exports.EThirdPartyRole = EThirdPartyRole = {}));
var EThirdPartyAuthMethod;
(function (EThirdPartyAuthMethod) {
    EThirdPartyAuthMethod["EMAIL_CODE"] = "EMAIL_CODE";
    EThirdPartyAuthMethod["SMS_CODE"] = "SMS_CODE";
})(EThirdPartyAuthMethod || (exports.EThirdPartyAuthMethod = EThirdPartyAuthMethod = {}));
class FolderThirdParty extends Resource_1.default {
}
exports.default = FolderThirdParty;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "folder_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "added_by_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "contact_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(EThirdPartyRole),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "role_type", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(255),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "role_description", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(255),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "company_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(255),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "first_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(255),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "last_name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.MaxLength)(255),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "email", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(20),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "phone", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EThirdPartyAuthMethod),
    __metadata("design:type", String)
], FolderThirdParty.prototype, "auth_method", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], FolderThirdParty.prototype, "email_verified", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], FolderThirdParty.prototype, "phone_verified", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "last_login", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "access_code", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, classTransformer_1.Type)(() => Contact_1.default),
    __metadata("design:type", Object)
], FolderThirdParty.prototype, "contact", void 0);
